// src/features/system/auth/RequireAuth.tsx
import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/shared/auth';

export default function RequireAuth() {
  const location = useLocation();
  const { user, loading, refresh } = useAuth();

  // Kick a refresh if we somehow mounted without a user and not loading
  React.useEffect(() => {
    if (!user && !loading) void refresh();
  }, [user, loading, refresh]);

  if (loading) return null; // could render spinner here
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  return <Outlet />;
}
